import {Component, DestroyRef, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {LookupService} from '../../../common/service/lookup.service';
import {GraphicSelectionService} from '../../services/graphic-selection.service';
import {NgEventBus} from 'ng-event-bus';
import {SelectionMethodLookup} from '../../../common/models/selection-method.model';
import {FeatureClassSelectionLookup} from '../../../common/models/feature-class-selection.model';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'nlr-selection-methods',
    imports: [FormsModule, NgSelectModule],
    providers: [CommonModule],
    templateUrl: './selection-methods.component.html',
    styleUrls: ['./selection-methods.component.scss']
})
export class SelectionMethodsComponent implements OnInit {
    @Input()
    disabled: boolean;

    title: string = 'SelectionMethodsComponent';

    selectionMethods: SelectionMethodLookup[] = [];

    selectionMethod: SelectionMethodLookup;

    featureClassSelectionMethods: FeatureClassSelectionLookup[] = [];

    featureClassSelectionMethod: FeatureClassSelectionLookup;

    constructor(
        private eventBus: NgEventBus,
        private lookupService: LookupService,
        private graphicSelectionService: GraphicSelectionService,
        private destroyRef: DestroyRef
    ) {}

    ngOnInit(): void {
        this.selectionMethods = this.lookupService.getLookups('selectionMethod');
        this.selectionMethod = this.selectionMethods.find(s => s.defaultSelection === true);

        this.featureClassSelectionMethods = this.lookupService.getLookups('featureClassSelection');
        this.featureClassSelectionMethod = this.featureClassSelectionMethods[0];

        this.graphicSelectionService.setSelectionMethod(this.selectionMethod);
        this.graphicSelectionService.setFeatureClass(this.featureClassSelectionMethod);

        this.eventBus
            .on('selectionMethodChange')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                console.debug(`${this.title} - Selection Method Change`);
                this.selectionMethodChange();
            });
    }

    selectionMethodChange() {
        console.debug(this.title, 'selectionMethodChange');
        this.graphicSelectionService.setSelectionMethod(this.selectionMethod);
    }

    featureClassSelectionMethodChange() {
        console.debug(this.title, 'featureClassSelectionMethodChange');
        this.graphicSelectionService.setFeatureClass(this.featureClassSelectionMethod);
        this.graphicSelectionService.featureClassSelectionChanged();
    }
}
